import { useState, useMemo } from 'react'
import { PostPreview } from './PostPreview'
import { postListNewImages } from '../../services/images.service'

export function PostPreviewList({ posts, onRemovePost, authorMap }) {
  const [visiblePosts, setVisiblePosts] = useState(9)

  const handleLoadMore = () => {
    setVisiblePosts((prev) => prev + 6)
  }

  // מיין לפי תאריך יורד (חדש לישן)
  const sortedPosts = useMemo(() => {
    return [...posts].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
  }, [posts])

  const displayedPosts = sortedPosts.slice(0, visiblePosts)

  return (
    <div className="container mx-auto">
      {posts.length === 0 ? (
        <p className="text-center">אין פוסטים להצגה</p>
      ) : (
        <>
          <h2 className="text-xl">כל הכתבות באתר</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {displayedPosts.map((post) => (
              <PostPreview
                key={post._id}
                post={post}
                onRemovePost={onRemovePost}
                author={authorMap[post.author?.userId]}
              />
            ))}
          </div>

          {visiblePosts < posts.length && (
            <div className="flex justify-center mt-6">
              <button
                style={{
                  background: `url(${postListNewImages.blockBtn}) no-repeat center/contain`,
                }}
                className="px-4 py-2 w-[130px] h-[40px] text-buttonSecondary1"
                onClick={handleLoadMore}
              >
                טען עוד
              </button>
            </div>
          )}
        </>
      )}
    </div>
  )
}
